import { createSvgIcon } from '@mui/material';

const ControlCenterDropIcon = createSvgIcon(
  <svg viewBox="0 0 24.023 26.087">
    <circle cx="10.7" cy="16.9" r="1.3" fill="currentColor" />
    <path
      d="M9.5,9.6v3.8c0,0.5,0.5,1,1.2,1s1.2-0.4,1.2-1V9.6c0-0.5-0.5-1-1.2-1S9.5,9,9.5,9.6z"
      fill="currentColor"
    />
    <path
      d="M10.7,0c0,0-8.7,9.2-7.9,15.8c0.9,6.6,6.6,7.3,7.9,7.3s7-0.7,7.9-7.3C19.4,9.2,10.7,0,10.7,0zM12.4,20 c-1.1,0.4-2.3,0.4-3.4,0c-3.6-1.4-4.1-4.3-3.2-7.3c1.1-3.4,4.8-8.3,4.8-8.3s3.7,4.9,4.9,8.3C16.5,15.7,16,18.6,12.4,20z"
      fill="currentColor"
    />
  </svg>,
  'ControlCenterDrop',
);

export default ControlCenterDropIcon;
